export enum MathematicalOperationEnum {
    None = 0,
    Addition = 1,
    Subtraction = 2,
    Multiplication = 3,
    Division = 4,
    Between = 5,
    GreaterThan = 6,
    LessThan = 7
}